export default __webpack_public_path__ + "static/0150-8d684553e5afb9c2b53cb8d20104f0c3.png";